jQuery( document ).ready(function( $ ) {
  document.addEventListener("scroll", function() {
    var header = document.querySelector(".main-header");
    if (window.scrollY > 50) {
        header.classList.add("sticky-header-real"); // Apply white background
    } else {
        header.classList.remove("sticky-header-real"); // Keep it transparent at the top
    }
});
});